import FupExerciseSettingListModelBase from '../_generated/modelBases/fup-exercise-setting-list-model-base';

export default class FupExerciseSettingListModel extends FupExerciseSettingListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
